"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TRANSFER_TYPE = exports.BUSINESS_MANAGER_TABS = exports.TAB_PATHS = void 0;
var generalSettings_svg_1 = __importDefault(require("@src/components/Icon/generalSettings.svg"));
var contentManagement_svg_1 = __importDefault(require("@src/components/Icon/contentManagement.svg"));
var channels_svg_1 = __importDefault(require("@src/components/Icon/channels.svg"));
var botPrompt_svg_1 = __importDefault(require("@src/components/Icon/botPrompt.svg"));
var cart_svg_1 = __importDefault(require("@src/components/Icon/cart.svg"));
var cart2_svg_1 = __importDefault(require("@src/components/Icon/cart2.svg"));
exports.TAB_PATHS = {
    GENERAL_SETTINGS: 'general-settings',
    CONTENT_MANAGEMENT: 'cms',
    CHANNELS: 'channels',
    BOT_PROMPT: 'bot-prompt',
    COMMERCE_PLUS: 'commerce-plus',
    GEN_AI_SALES_ASSISTANT: 'gen-AI-sales-assistant',
};
exports.BUSINESS_MANAGER_TABS = [
    {
        title: 'General Settings',
        icon: generalSettings_svg_1["default"],
        path: exports.TAB_PATHS.GENERAL_SETTINGS,
    },
    {
        title: 'Content Management',
        icon: contentManagement_svg_1["default"],
        path: exports.TAB_PATHS.CONTENT_MANAGEMENT,
    },
    {
        title: 'Channels',
        icon: channels_svg_1["default"],
        path: exports.TAB_PATHS.CHANNELS,
    },
    {
        title: 'Bot Prompt Triggers',
        icon: botPrompt_svg_1["default"],
        path: exports.TAB_PATHS.BOT_PROMPT,
    },
    {
        title: 'Commerce+',
        icon: cart_svg_1["default"],
        path: exports.TAB_PATHS.COMMERCE_PLUS,
    },
    {
        title: 'Gen AI Sales Assistant',
        icon: cart2_svg_1["default"],
        path: exports.TAB_PATHS.GEN_AI_SALES_ASSISTANT,
    },
];
exports.TRANSFER_TYPE = {
    BUSINESS: 'business',
    TASK: 'task',
    TRIGGER: 'trigger',
};
